import {
  CalendarIcon,
  FolderIcon,
  HomeIcon,
  UserIcon,
  LockClosedIcon,
  TicketIcon,
  ShoppingBagIcon,
  ChatBubbleLeftRightIcon,
} from "@heroicons/react/24/solid";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const MobileBottomNav = () => {
  const { isAdmin, isApproved } = useAuth();

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-49">
      <div className="flex justify-around items-center py-2 mb-10">
        {/* Home Button */}
        <NavLink
          to="/portal/dashboard"
          className={({ isActive }) =>
            `flex flex-col items-center justify-center p-2 ${
              isActive ? "text-gold" : "text-gray-600"
            } hover:text-gold`
          }
        >
          <HomeIcon className="h-6 w-6" />
          <span className="text-xs mt-1">Dashboard</span>
        </NavLink>

        {/* Events Button - Only show if approved or admin */}
        {(isApproved || isAdmin) && (
          <NavLink
            to="/portal/events"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center p-2 ${
                isActive ? "text-gold" : "text-gray-600"
              } hover:text-gold`
            }
          >
            <CalendarIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Events</span>
          </NavLink>
        )}

        {/* Tickets Button - Only show if approved or admin */}
        {(isApproved || isAdmin) && (
          <NavLink
            to="/portal/tickets"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center p-2 ${
                isActive ? "text-gold" : "text-gray-600"
              } hover:text-gold`
            }
          >
            <TicketIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Tickets</span>
          </NavLink>
        )}

        {/* Resources Button - Only show if approved or admin */}
        {(isApproved || isAdmin) && (
          <NavLink
            to="/portal/resources"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center p-2 ${
                isActive ? "text-gold" : "text-gray-600"
              } hover:text-gold`
            }
          >
            <FolderIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Resources</span>
          </NavLink>
        )}

        {/* Profile Button */}
        <NavLink
          to="/portal/profile"
          className={({ isActive }) =>
            `flex flex-col items-center justify-center p-2 ${
              isActive ? "text-gold" : "text-gray-600"
            } hover:text-gold`
          }
        >
          <UserIcon className="h-6 w-6" />
          <span className="text-xs mt-1">Profile</span>
        </NavLink>

        {/* Admin Button - Only show if user is admin */}
        {isAdmin && (
          <NavLink
            to="/portal/admin"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center p-2 ${
                isActive ? "text-gold" : "text-gray-600"
              } hover:text-gold`
            }
          >
            <LockClosedIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Admin</span>
          </NavLink>
        )}
      </div>
    </div>
  );
};

export default MobileBottomNav;
